// extracted by mini-css-extract-plugin
export default {"right":"DestacadoCard_right__hNQuB","img":"DestacadoCard_img__UG3cG","title":"DestacadoCard_title__jFKJi","subTitle":"DestacadoCard_subTitle__aQEZA"};